



























import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'

export default {
    name: 'oncall_duties_table'

    props:
        component:
            type: String
            required: true
        reload:
            type: Boolean
            required: false

    watch:
        reload: (new_reload, old_reload)->
            if new_reload != old_reload
                @get_oncall_duties()

    data: ()->
        alert: false
        loading: true
        search: ''
        pager_count: 5
        current_page: 1
        page_size: 10
        oncall_duties: []

    computed:
        data_filtered: ()->
            self = @
            data = @oncall_duties.filter (x) ->
                modified = self.date_formatter(x.modified)
                !self.search || modified.includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

    methods:
        date_formatter: t.date_formatter
        has_access_right: t.has_access_right

        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            @oncall_duties.sort (a,b)->
                modifier = 1
                if order == 'descending'
                    modifier = -1
                return a[prop].toLowerCase().localeCompare(b[prop].toLowerCase())*modifier
            # console.log "ONCALLDUTIES SORT ", @oncall_duties

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        download_file: (oncall_duty)->
            url = settings.media_url+oncall_duty.file_dir+'/'+oncall_duty.file
            filename = oncall_duty.complete_filename
            t.download_file(url, filename)
            return

        delete_oncall_duty: (oncall_duty_uid)->
            @$emit('delete-oncallduty', oncall_duty_uid)
            return

        get_oncall_duties: ()->
            self = @
            @loading = true
            q.run('get_oncall_duty_set', [@$store.getters.current_company.uid, @component])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error(self.component+"_oncall_duties: get_oncall_duties: then", e.message)
                else
                    # console.log "GET oncall_duties : ", resp.body.data.oncall_duty_set
                    self.oncall_duties = resp.body.data.oncall_duty_set
                    self.loading = false
                    if self.oncall_duties.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "oncall_duties_table: get_oncall_duties()")
            
    beforeMount: ()->
        # console.log "oncall_duties_table mounted"
        @get_oncall_duties()
}
